import { CONTEXT_TAG_TONE, LEAP_V4_SCOPE } from './constants';

// Prototype-less because the key is server-supplied: off a plain literal,
// `toString` would resolve to an inherited function and yield a label-less chip.
const V4_SCOPES = Object.assign(Object.create(null), {
  [LEAP_V4_SCOPE.ALL]: { label: 'V4', tone: CONTEXT_TAG_TONE.V4 },
  [LEAP_V4_SCOPE.MIXED]: { label: 'V4 + V3', tone: CONTEXT_TAG_TONE.MIXED },
  // NONE is deliberately absent, so it draws no chip — it is ~96% of tickets.
});

export const studentTags = student => {
  const tags = [];
  if (student?.is_eval) {
    tags.push({ label: 'Eval', tone: CONTEXT_TAG_TONE.EVAL });
  }
  if (student?.is_leap_v4_enabled) {
    tags.push({ label: 'V4', tone: CONTEXT_TAG_TONE.V4 });
  }
  return tags;
};

export const buildCustomerTags = (agentSignals, involvedStudents) => {
  const students = involvedStudents || [];
  const tags = [];
  if (agentSignals?.is_coach) {
    tags.push({ label: 'Coach', tone: CONTEXT_TAG_TONE.COACH });
  }
  // Scoped to the ticket's students, not the customer's roster: with none
  // involved, the chip would be a guess.
  const scope = students.length ? V4_SCOPES[agentSignals?.leap_v4_scope] : null;
  if (scope) {
    tags.push({ label: scope.label, tone: scope.tone });
  }
  return tags;
};
